import script from "./Particles.vue?vue&type=script&setup=true&lang=js"
export * from "./Particles.vue?vue&type=script&setup=true&lang=js"

import "./Particles.vue?vue&type=style&index=0&id=ec012826&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec012826"]])

export default __exports__